import { IconButton } from '@synoptic/ui-kit/button/icon-button.js';
import { SettingsIcon } from '@synoptic/ui-kit/icons/react/settings.js';
import { useIsTablet } from '@synoptic/ui-kit/responsive/hooks.js';
import { FC, useState } from 'react';
import { SoundSettingsModal } from '@/components/status-bar/sound-settings-modal';
import {
  getStreamNotifSoundStatus,
  setStreamNotifSoundStatus,
} from '@/components/streams/toggle-notif-sound/stream-notif-sound-status.ts';
import { SoundButton } from '@/components/toggle-sound/sound-button.tsx';
import { SoundTrack } from '@/components/toggle-sound/sound-settings';
import { SoundStatus } from '@/components/toggle-sound/sound-status.ts';
import {
  useStreamSoundSettings,
  setStreamSoundTrack,
  setStreamSoundVolume,
} from './stream-sound-settings';
import { soundButtonContainer } from './stream-sound-button.css';

export const StreamSoundButton: FC<{ streamId: string }> = ({ streamId }) => {
  const isTablet = useIsTablet();
  const [currentSoundStatus, setCurrentSoundStatus] = useState(
    getStreamNotifSoundStatus(streamId),
  );
  const [showSettings, setShowSettings] = useState(false);
  const soundSettings = useStreamSoundSettings(streamId);

  const onToggleSound = () => {
    const newStatus =
      currentSoundStatus === SoundStatus.on ? SoundStatus.off : SoundStatus.on;

    setStreamNotifSoundStatus(newStatus, streamId);
    setCurrentSoundStatus(newStatus);
  };

  const handleTrackChange = (track: SoundTrack) => {
    setStreamSoundTrack(streamId, track);
  };

  const handleVolumeChange = (volume: number) => {
    setStreamSoundVolume(streamId, volume);
  };

  return (
    <>
      <div className={soundButtonContainer}>
        <SoundButton soundStatus={currentSoundStatus} onClick={onToggleSound} />
        <IconButton
          variant="secondary"
          rounded={false}
          size={isTablet ? 'medium' : 'small'}
          onClick={() => setShowSettings(true)}
          aria-label="Sound settings"
        >
          <SettingsIcon />
        </IconButton>
      </div>

      <SoundSettingsModal
        open={showSettings}
        onOpenChange={setShowSettings}
        settings={soundSettings as { track: SoundTrack; volume: number }}
        soundStatus={currentSoundStatus}
        showHighlightSettings={false}
        onToggleSound={onToggleSound}
        onTrackChange={handleTrackChange}
        onVolumeChange={handleVolumeChange}
      />
    </>
  );
};
